import { render, staticRenderFns } from "./DialogShowVideoHoch.vue?vue&type=template&id=162bb07c&scoped=true"
import script from "./DialogShowVideoHoch.vue?vue&type=script&lang=js"
export * from "./DialogShowVideoHoch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162bb07c",
  null
  
)

export default component.exports